/**
 * 📋 SDLC 6.3.1 UNIFIED SPECIFICATION STANDARD FILE HEADER
 * ===============================================================================
 * FILE: frontend/src/hooks/queryKeys.ts
 * PURPOSE: Centralized TanStack Query keys — shared between useEmployeeDashboard and useWebSocket
 * SDLC FRAMEWORK VERSION: 6.5.0 (7-Pillar + 9 Mental Models + Long-Running Agent Protocol)
 * PILLAR: P1 (Stage 04 - BUILD) + P2 (Sprint Governance)
 * SPRINT GOVERNANCE: Rule 3: Zero-Mock Tolerance
 *
 * @business-context
 * - Domain: Cache Invalidation, Query Key Management
 * - Impact: Prevents circular dependency between hooks
 * - Stakeholders: Frontend Engineers
 *
 * @technical-architecture
 * - Layer: Shared Constants
 * - Pattern: Query Key Factory (TanStack Query best practice)
 * - Dependencies: None (pure constants)
 *
 * @cross-references
 * - Decision: docs/02-design/18-adrs/06-decisions/DD-0026-employee-dashboard-realtime-offline-architecture.md
 * - Consumer: frontend/src/hooks/useEmployeeDashboard.ts
 * - Consumer: frontend/src/hooks/useWebSocket.ts
 */

export const DASHBOARD_QUERY_KEYS = {
  attendanceStatus: ['employee', 'attendance-status'] as const,
  pendingTasks: ['employee', 'tasks', 'pending'] as const,
  todaySchedule: ['employee', 'schedule', 'today'] as const,
  tomorrowSchedule: ['employee', 'schedule', 'tomorrow'] as const,
  taskSummary: ['employee', 'tasks', 'summary'] as const,
  /** PR #603 sync (2026-08-12, BS-300 §1bis-G5) — tenant-configured early
   * clock-in tolerance, read from the same GPS branches/locations response
   * mobile uses (backend/app/api/v1/gps_attendance.py get_branch_locations). */
  earlyClockinTolerance: ['employee', 'attendance', 'early-clockin-tolerance'] as const,
  /** #704 (BOT-015) — GET /schedules/my-schedule/draft-status, month window;
   * queried only when the month schedule is empty (FRESH candidate). */
  monthScheduleDraftStatus: ['employee', 'schedule', 'month-draft-status'] as const,
  all: ['employee'] as const,
};
